import { useState } from 'react';

import {
  Card,
  CardContent,
  CardFooter,
  FormControl,
  FormField,
  FormItem,
  Input,
  Label,
  LoadingButton,
  Textarea,
} from '@crossnokaye/ux-common';

import { CopyTokenDialog } from './copy-token-dialog';
import { CreateTokenForm } from './create-token-form';

export const CreateTokenCard = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [generatedToken, setGeneratedToken] = useState<string>('');

  const onTokenCreated = (token: string) => {
    setGeneratedToken(token);
    setIsOpen(true);
  };

  return (
    <Card>
      <CreateTokenForm onSuccess={onTokenCreated}>
        {(form) => (
          <>
            <CardContent className={'pt-6 space-y-4'}>
              <FormField
                control={form.control}
                name={'name'}
                render={({ field }) => (
                  <FormItem>
                    <Label htmlFor={'name'}>{'Name'}</Label>
                    <FormControl>
                      <Input id={'name'} placeholder={'e.g., Development API Token'} {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name={'description'}
                render={({ field }) => (
                  <FormItem>
                    <Label htmlFor={'description'}>{'Description (optional)'}</Label>
                    <FormControl>
                      <Textarea
                        id={'description'}
                        placeholder={'Enter a description for this token'}
                        className={'resize-none'}
                        {...field}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
              <CopyTokenDialog token={generatedToken} isOpen={isOpen} onClose={setIsOpen} />
            </CardContent>
            <CardFooter className={'flex justify-end'}>
              <LoadingButton
                size={'lg'}
                className={'min-w-48'}
                type={'submit'}
                disabled={!form.formState.isValid || form.formState.isSubmitting}
                isLoading={form.formState.isSubmitting}
              >
                {'Generate Token'}
              </LoadingButton>
            </CardFooter>
          </>
        )}
      </CreateTokenForm>
    </Card>
  );
};
